import React from "react";
import PT from "prop-types";
import { Link } from "@quintype/components";
import "./menu-item.m.css";

import { RADIOT_HELSINKI, RADIOT_KAJANI, RADIOT_KEMI, RADIOT_KOKKOLA, RADIOT_KRISTIINANKAUPPUNKI, RADIOT_LAHTI, RADIOT_OULU, RADIOT_ROVANIEMI, RADIOT_TORNIO, RADIOT_TURKU, RADIOT_YLEISOHJELMA } from "../../store/actions";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useState } from "react";

const MenuItem = ({ item, toggleHandler, menuStyle = "menu-link", navSelected, setNavSelected }) => {
  const dispatch = useDispatch();
  const [isUseinKysActive, setIsUseinKysActive] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const currentPath = window.location.pathname.replace(/\/$/, "");
      setIsUseinKysActive(currentPath === "/usein-kysyttya");
    }
  }, []);

  if (item["item-type"] === "placeholder") {
    return item.title === "RADIOT" ? (
      <Link href="/radiot">
        <div styleName={menuStyle} onClick={toggleHandler} className={menuStyle}>
          <span
            onClick={() => {
              setNavSelected("radiot");
              dispatch({
                type: RADIOT_HELSINKI,
                isRadiotHelsinkiClicked: false,
              });
              dispatch({
                type: RADIOT_LAHTI,
                isRadiotLahtiClicked: false,
              });
              dispatch({
                type: RADIOT_ROVANIEMI,
                isRadiotRovaniemiClicked: false,
              });
              dispatch({
                type: RADIOT_OULU,
                isRadiotOuluClicked: false,
              });
              dispatch({
                type: RADIOT_YLEISOHJELMA,
                isRadiotYleisohjelmaClicked: false,
              });
              dispatch({
                type: RADIOT_KAJANI,
                isRadiotKajaniClicked: false,
              });
              dispatch({
                type: RADIOT_TURKU,
                isRadiotTurkuClicked: false,
              });
              dispatch({
                type: RADIOT_KEMI,
                isRadiotKemiClicked: false,
              });
              dispatch({
                type: RADIOT_TORNIO,
                isRadiotTornioClicked: false,
              });
              dispatch({
                type: RADIOT_KOKKOLA,
                isRadiotKokkolaClicked: false,
              });
              dispatch({
                type: RADIOT_KRISTIINANKAUPPUNKI,
                isRadiotKristiinankauppunkiClicked: false,
              });
            }}
            styleName={`menu-link nav-item-kanavat ${navSelected === "radiot" ? "active" : ""}`}
          >
             RADIO DEI
          </span>
        </div>
      </Link>
    ) : (
      <div styleName={menuStyle} onClick={toggleHandler} className={menuStyle}>
        <span
          onClick={() => {
            setNavSelected(item.title);
            dispatch({
              type: RADIOT_HELSINKI,
              isRadiotHelsinkiClicked: false,
            });
            dispatch({
              type: RADIOT_LAHTI,
              isRadiotLahtiClicked: false,
            });
            dispatch({
              type: RADIOT_ROVANIEMI,
              isRadiotRovaniemiClicked: false,
            });
            dispatch({
              type: RADIOT_OULU,
              isRadiotOuluClicked: false,
            });
            dispatch({
              type: RADIOT_YLEISOHJELMA,
              isRadiotYleisohjelmaClicked: false,
            });
            dispatch({
              type: RADIOT_KAJANI,
              isRadiotKajaniClicked: false,
            });
            dispatch({
              type: RADIOT_TURKU,
              isRadiotTurkuClicked: false,
            });
            dispatch({
              type: RADIOT_KEMI,
              isRadiotKemiClicked: false,
            });
            dispatch({
              type: RADIOT_TORNIO,
              isRadiotTornioClicked: false,
            });
            dispatch({
              type: RADIOT_KOKKOLA,
              isRadiotKokkolaClicked: false,
            });
            dispatch({
              type: RADIOT_KRISTIINANKAUPPUNKI,
              isRadiotKristiinankauppunkiClicked: false,
            });
          }}
          styleName={`menu-link nav-item-kanavat ${navSelected === item.title ? "active" : ""}`}
        >
          {item.title}
        </span>
      </div>
    );
  } else if (item["item-type"] === "link") {
    return (
      <div class="dropdown">
          <a href="/usein-kysyttya">
              <div class="menu-link menu-item">
                  <span styleName={`menu-link nav-item-kanavat ${isUseinKysActive ? "active" : ""}`} style={{fontWeight: 700}}>
                      OHJEET JA APUA
                  </span>
              </div>
          </a>
      </div>
    );
  } else {
    return (
      <Link aria-label="menu-item" callback={toggleHandler} className={menuStyle} href={item.completeUrl || "/"}>
        <span
          styleName={`${menuStyle} nav-item-kanavat ${
            navSelected && navSelected === "podcastit-ja-videot" ? "active" : ""
          }`}
          onClick={() => {
            setNavSelected("podcastit-ja-videot");
            dispatch({
              type: RADIOT_HELSINKI,
              isRadiotHelsinkiClicked: false,
            });
            dispatch({
              type: RADIOT_ROVANIEMI,
              isRadiotRovaniemiClicked: false,
            });
            dispatch({
              type: RADIOT_LAHTI,
              isRadiotLahtiClicked: false,
            });
            dispatch({
              type: RADIOT_OULU,
              isRadiotOuluClicked: false,
            });
            dispatch({
              type: RADIOT_YLEISOHJELMA,
              isRadiotYleisohjelmaClicked: false,
            });
            dispatch({
              type: RADIOT_KAJANI,
              isRadiotKajaniClicked: false,
            });
            dispatch({
              type: RADIOT_TURKU,
              isRadiotTurkuClicked: false,
            });
            dispatch({
              type: RADIOT_KEMI,
              isRadiotKemiClicked: false,
            });
            dispatch({
              type: RADIOT_TORNIO,
              isRadiotTornioClicked: false,
            });
            dispatch({
              type: RADIOT_KOKKOLA,
              isRadiotKokkolaClicked: false,
            });
            dispatch({
              type: RADIOT_KRISTIINANKAUPPUNKI,
              isRadiotKristiinankauppunkiClicked: false,
            });
          }}
        >
          {item.title}
        </span>
      </Link>
    );
  }
};

MenuItem.propTypes = {
  item: PT.object,
  showIcon: PT.bool,
};

export { MenuItem };
